exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n  padding: 2em;\n  max-width: calc(100% - 2em * 2);\n  max-height: calc(100vh - 2em * 2 - 8em);\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?sourceMap!./src/viega-common/components/viega-image-dialog/viega-image-dialog.component.scss
// module id = 0wqY
// module chunks = 5